import 'lazysizes'

import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

import featureWeekSpeakers from '../components/featureWeekSpeakers'
import leadersList from '../components/leadersList'
import siteMenu from '../components/siteMenu'
import subPageCards from '../components/subPageCards'
import imageSlider from '../components/imageSlider'
import subPageCarousel from '../components/subpageCarousel'
import svgWave from '../components/svgWave'
import tabGroup from '../components/tabGroup'

export default {
	init() {
		// JavaScript to be fired on all pages
		CookieConsent.run({
			guiOptions: {
				consentModal: {
					layout: 'box',
					position: 'bottom left',
					equalWeightButtons: false,
					flipButtons: false,
				},
				preferencesModal: {
					layout: 'box',
					position: 'right',
					equalWeightButtons: true,
					flipButtons: true,
				},
			},
			categories: {
				necessary: {
					readOnly: true,
				},
				analytics: {
					enabled: true,
				},
			},
			language: {
				default: 'en',
				autoDetect: 'browser',
				translations: {
					en: {
						consentModal: {
							title: 'We use cookies',
							description:
								'This website uses cookies to ensure you get the best experience on our website.',
							closeIconLabel: '',
							acceptAllBtn: 'Accept all',
							acceptNecessaryBtn: 'Reject all',
							showPreferencesBtn: 'Cookie settings',
							footer: '<a href="/privacy-policy">Privacy policy</a>',
						},
						preferencesModal: {
							title: 'Consent Preferences Center',
							closeIconLabel: 'Close modal',
							acceptAllBtn: 'Accept all',
							acceptNecessaryBtn: 'Reject all',
							savePreferencesBtn: 'Save preferences',
							serviceCounterLabel: 'Service|Services',
							sections: [
								{
									title: 'Cookie Usage',
									description:
										'We use cookies to enhance your experience of using our website. Some essential features on our website won’t work without cookies.',
								},
								{
									title:
										'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
									description:
										'These cookies are required in order for the website to work as intended.',
									linkedCategory: 'necessary',
								},
								{
									title: 'Analytics Cookies',
									description:
										'These cookies help us enhance the website so we can anonymously analyse how people engage with our website..',
									linkedCategory: 'analytics',
								},
								{
									title: 'More information',
									description:
										'For any query in relation to our policy on cookies and your choices, please <a class="cc__link" href="/about-us/contact-us">contact us</a>.',
								},
							],
						},
					},
				},
			},
		})
	},
	finalize() {
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
		mediaQuery.addEventListener('change', () => {
			console.log(mediaQuery.media, mediaQuery.matches)
			// Stop JavaScript-based animations.
		})

		/* Select input back button fix */
		// https://stackoverflow.com/questions/4370819/select-menu-not-being-restored-when-back-button-used
		let selects = document.getElementsByTagName('select')
		for (let i = 0; i < selects.length; ++i) {
			let currentSelect = selects[i]
			let selectedOption = currentSelect.querySelector('option[selected]')
			if (selectedOption) currentSelect.value = selectedOption.value
		}

		/*
		 * Booking Process
		 */
		const indicatorWrapper = document.querySelector('.booking-page-indicator')
		const indicatorPageItems = document.querySelectorAll(
			'.booking-page-indicator .indicator-pages .indicator-page'
		)
		const indicatorPageButtons = document.querySelectorAll(
			'.booking-page-indicator .indicator-pages .indicator-page button'
		)
		indicatorPageButtons.forEach(function (ibutton) {
			ibutton.addEventListener('click', function () {
				indicatorPageItems.forEach(function (i) {
					i.classList.remove('active')
				})
				ibutton.parentElement.classList.add('active')
				var newpage = ibutton.parentElement.getAttribute('data-page')
				indicatorWrapper.setAttribute('data-page', newpage)
			})
		})
		const breakdownBlock = document.querySelector('.booking-breakdown')
		const breakdownToggle = document.querySelectorAll('.booking-breakdown h2')
		breakdownToggle.forEach(function (toggle) {
			toggle.addEventListener('click', function () {
				breakdownBlock.classList.toggle('active')
			})
		})

		/*
		 * All Escape Key Closers
		 */
		document.onkeydown = function (evt) {
			evt = evt || window.event
			var isEscape = false
			if ('key' in evt) {
				isEscape = evt.key === 'Escape' || evt.key === 'Esc'
			} else {
				isEscape = evt.keyCode === 27
			}
			if (isEscape) {
				const fwSpeakers = document.querySelectorAll('.feature-week-guest')
				fwSpeakers.forEach(function (fwSpeaker) {
					const bio = fwSpeaker.querySelector('.feature-week-guest-bio')
					if (bio !== null) {
						bio.classList.remove('active')
					}
				})
				const facilitycards = document.querySelectorAll('.facility-card')
				facilitycards.forEach((card) =>
					card.querySelector('.facility-popup').classList.remove('open')
				)
				if (window.location.hash) {
					window.location.hash = '/'
				}
			}
		}

		// Updated
		$(document).on('click', '.landingpage a.js-brochure', function (e) {
			if ($(e.target).text().indexOf('View brochure') >= 0) {
				e.preventDefault()
				Fancybox.show([{ src: '#brochure-signup', type: 'inline' }])
				return false
			}
		})

		featureWeekSpeakers.init()
		leadersList.init()
		siteMenu.init()
		subPageCards.init()
		imageSlider.init()
		subPageCarousel.init()
		svgWave.init()
		tabGroup.init()
	},
}
